import APIClient from '@/shared/http/clients/api'

const resourceName = 'ObraVinculoSAP'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

// Empreendimentos do SAP (1º dropdown)
const GetEmpreendimentosSap = (data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/empreendimentos-sap`, data, config)

// Unidades/casas do SAP de um empreendimento (2º dropdown)
const GetUnidadesSap = (codEmp, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/empreendimentos-sap/${codEmp}/unidades`, data, config)

// Casas do SAP por obra local (fluxo QMA)
const GetCasasSapPorObra = (obraId, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/obra/${obraId}/casas-sap`, data, config)

// Casas do SAP por referência de obra (fallback QMA)
const GetCasasSapPorReferencia = (referencia, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/casas-sap/referencia/${encodeURIComponent(referencia)}`, data, config)

// Casas do SAP de um QMA (server resolve obra->referência)
const GetCasasSapPorQma = (qmaId, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/qma/${qmaId}/casas-sap`, data, config)

// Une uma casa (cria/merge o ObraVinculoSAP) e devolve com o id
const UnirCasa = (casa, config = {}) =>
  APIClient.post(`${APIBusinessCommon}/${resourceName}/unir-casa`, casa, config)

// Liga um QMA à casa
const VincularQma = (qmaId, vinculoId, data = {}, config = {}) =>
  APIClient.post(`${APIBusinessCommon}/${resourceName}/qma/${qmaId}/vincular-casa/${vinculoId}`, data, config)

// Desliga o QMA da casa (zera qma.ObraVinculoSAPId)
const DesvincularQma = (qmaId, data = {}, config = {}) =>
  APIClient.post(`${APIBusinessCommon}/${resourceName}/qma/${qmaId}/desvincular-casa`, data, config)

// Relatorio "Relacao de LVs e vistorias" de uma obra (so casas ja unidas)
const GetRelatorioLvs = (obraId, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/obra/${obraId}/relatorio-lvs`, data, config)

// Mesmo relatorio filtrando pelo nome do empreendimento (SAP)
const GetRelatorioLvsPorEmpreendimento = (empreendimento, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/empreendimento/relatorio-lvs?empreendimento=${encodeURIComponent(empreendimento)}`, data, config)

// Mesmo relatorio filtrando por texto parcial do codigo da obra (autocomplete sem selecao fechada)
const GetRelatorioLvsPorTextoObra = (texto, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/obra/relatorio-lvs-por-texto?texto=${encodeURIComponent(texto)}`, data, config)

// Obras candidatas ao autocomplete do relatorio de LVs (so as que ja tem QMA vinculado)
const GetObrasParaRelatorioLvs = (texto, data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/obra/relatorio-lvs/obras-busca?texto=${encodeURIComponent(texto)}`, data, config)

// Empreendimentos candidatos ao autocomplete do relatorio de LVs (das casas ja unidas)
const GetEmpreendimentosParaRelatorioLvs = (data = {}, config = {}) =>
  APIClient.get(`${APIBusinessCommon}/${resourceName}/empreendimento/relatorio-lvs/empreendimentos-busca`, data, config)

const ObraVinculoSapRepository = {
  GetEmpreendimentosSap,
  GetUnidadesSap,
  GetCasasSapPorObra,
  GetCasasSapPorReferencia,
  GetCasasSapPorQma,
  UnirCasa,
  VincularQma,
  DesvincularQma,
  GetRelatorioLvs,
  GetRelatorioLvsPorEmpreendimento,
  GetRelatorioLvsPorTextoObra,
  GetObrasParaRelatorioLvs,
  GetEmpreendimentosParaRelatorioLvs
}

export default ObraVinculoSapRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/obraVinculoSap.js